function Calendar({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '21'} height=${dimensions || '22'} viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.5 2H17.5V0H15.5V2H5.5V0H3.5V2H2.5C1.4 2 0.5 2.9 0.5 4V20C0.5 21.1 1.4 22 2.5 22H18.5C19.6 22 20.5 21.1 20.5 20V4C20.5 2.9 19.6 2 18.5 2ZM18.5 20H2.5V9H18.5V20ZM18.5 7H2.5V4H18.5V7Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default Calendar;
